<div class="general-popup-content">
    <div class="deposit-column" [class.--slide]="toggler">
        <div class="left-content">
            <div *ngIf="!gameId" class="navigation-wrap full-width">
                <a class="navigation-link" *ngFor="let game of games"
                   [class.--current]="game === selected"
                   (click)="selected = game">
                    <div>{{ selectorName(game) }}</div>
                </a>
            </div>
            <form [formGroup]="form" novalidate>
                <app-form-input formControlName="clientSeed" title="Client seed" [disabled]="!!gameId"
                                data-id="modalFairness-clientSeed-readonly">
                </app-form-input>
                <app-form-input formControlName="serverSeed" (ngModelChange)="serverSeedHashed()"
                                [disabled]="!!gameId" title="Server seed" data-id="modalFairness-serverSeed-readonly">
                </app-form-input>
                <app-form-input formControlName="serverSeedHashed" title="Server seed (hashed)"
                                data-id="modalFairness-hashed-readonly"
                                disabled>
                </app-form-input>
            </form>
        </div>
        <div class="fairness-block" data-id="modalFairness-reply-readonly">
            <app-reply-dice *ngIf="selected === 'dice' || selected === 'spooky-dice' || selected === 'ice-dice'"
                            [gameId]="gameId"
                            [serverSeed]="form.get('serverSeed').value"
                            [playerSeed]="form.get('clientSeed').value">
            </app-reply-dice>
            <app-reply-blackjack *ngIf="selected === 'blackjack'"
                                 [gameId]="gameId"
                                 [serverSeed]="form.get('serverSeed').value"
                                 [playerSeed]="form.get('clientSeed').value">
            </app-reply-blackjack>
            <app-reply-baccarat *ngIf="selected === 'baccarat'"
                                [gameId]="gameId"
                                [serverSeed]="form.get('serverSeed').value"
                                [playerSeed]="form.get('clientSeed').value">
            </app-reply-baccarat>
            <app-reply-crash *ngIf="selected === 'crash'"
                             [gameId]="gameId"
                             [serverSeed]="form.get('serverSeed').value"
                             [playerSeed]="form.get('clientSeed').value">
            </app-reply-crash>
            <app-reply-slots *ngIf="selected === 'slots'"
                             [gameId]="gameId"
                             [serverSeed]="form.get('serverSeed').value"
                             [playerSeed]="form.get('clientSeed').value">
            </app-reply-slots>
            <app-reply-crypto-gems *ngIf="selected === 'crypto-gems'"
                             [gameId]="gameId"
                             [serverSeed]="form.get('serverSeed').value"
                             [playerSeed]="form.get('clientSeed').value">
            </app-reply-crypto-gems>
            <app-reply-greek-slots *ngIf="selected === 'under-the-aegis'"
                                   [gameId]="gameId"
                                   [serverSeed]="form.get('serverSeed').value"
                                   [playerSeed]="form.get('clientSeed').value">
            </app-reply-greek-slots>
            <app-reply-roulette *ngIf="selected === 'roulette'"
                             [gameId]="gameId"
                             [serverSeed]="form.get('serverSeed').value"
                             [playerSeed]="form.get('clientSeed').value">
            </app-reply-roulette>
            <app-reply-treasure-hunt *ngIf="selected === 'treasure-hunt'"
                                [gameId]="gameId"
                                [serverSeed]="form.get('serverSeed').value"
                                [playerSeed]="form.get('clientSeed').value">
            </app-reply-treasure-hunt>
            <app-reply-hi-lo *ngIf="selected === 'hi-lo'"
                                [gameId]="gameId"
                                [serverSeed]="form.get('serverSeed').value"
                                [playerSeed]="form.get('clientSeed').value">
            </app-reply-hi-lo>
            <app-reply-casino-war *ngIf="selected === 'casino-war'"
                             [gameId]="gameId"
                             [serverSeed]="form.get('serverSeed').value"
                             [playerSeed]="form.get('clientSeed').value">
            </app-reply-casino-war>
            <app-reply-video-poker *ngIf="selected === 'video-poker'"
                                [gameId]="gameId"
                                [serverSeed]="form.get('serverSeed').value"
                                [playerSeed]="form.get('clientSeed').value">
            </app-reply-video-poker>
        </div>
    </div>
  <app-form-button class="small primary change-seeds" (click)="toggler = !toggler" [hidden]="!toggler"><i class="fal fa-arrow-left"></i> Change seeds</app-form-button>
  <app-form-button class="small primary verify" (click)="toggler = !toggler" [hidden]="toggler">Verify <i class="fal fa-arrow-right"></i></app-form-button>

    <a [routerLink]="['/', {outlets: { modal: null } } ]" class="icon close-popup">
        <i class="fal fa-times"></i>
    </a>
</div>



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/_v2/template/modals/fairness/fairness-modal.template.html